export const shades = {
    primary: {
        dark: {
            5: 'rgba(9, 7, 25, 0.05)',
            10: 'rgba(9, 7, 25, 0.1)',
            30: 'rgba(9, 7, 25, 0.3)',
            40: 'rgba(9, 7, 25, 0.4)',
            100: 'rgb(9, 7, 25)',
        },
        light: {
            5: 'rgba(255, 255, 255, 0.05)',
            10: 'rgba(255, 255, 255, 0.1)',
            20: 'rgba(255, 255, 255, 0.2)',
            30: 'rgba(255, 255, 255, 0.3)',
            50: 'rgba(255, 255, 255, 0.5)',
            100: 'rgb(255, 255, 255)',
        },
    },
};
